<div class="button-action">
  <button *ngIf="showDelete" mat-icon-button (click)="delete.emit(true)">
    <mat-icon matTooltip="Eliminar">delete</mat-icon>
  </button>
  <button *ngIf="showEdit" mat-icon-button (click)="edit.emit(true)">
    <mat-icon matTooltip="Editar">edit</mat-icon>
  </button>
</div>